// extracted by mini-css-extract-plugin
export var bodyRow = "_e3-d";
export var cardColumns = "_e3-e";
export var ellipsesOverflow = "_e3-2";
export var flatBottomCorners = "_e3-3";
export var flatTopCorners = "_e3-4";
export var headerActionsDropdown = "_e3-f";
export var headerBottomRow = "_e3-c";
export var headerTopRow = "_e3-b";
export var orderDetailsWrapper = "_e3-0";
export var orderInfoContainer = "_e3-1";
export var productDetails = "_e3-9";
export var productImage = "_e3-5";
export var responsiveTable = "_e3-8";
export var shipmentContainer = "_e3-a";
export var tableBottomLeft = "_e3-6";
export var tableBottomRight = "_e3-7";
export var trackingLink = "_e3-g";